<template>
  <div>
    <div
      style="border: 1px solid #ccc;min-width:700px;"
    >
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
      />
      <Editor
        :id="`editor-`+ idNum"
        :style="{
            height: height + 'px',
            width: width + 'px',
          }"
        :defaultConfig="editorConfig"
        @onCreated="onCreated"
        @onChange="onChange"
        :mode="mode"
        v-model="sendData"
      />
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import '@wangeditor/editor/dist/css/style.css'
import fileService from '../../api/file/fileService'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default Vue.extend({
  components: { Editor, Toolbar },
  computed: {
    sendData: {
      get () {
        return this.contentHtml
      },
      set (value) {}
    },
    // 这个是为了限制字符，因为有多个而且每个的限制字符还不一样，这样每用一个你可以根据需求传入
    editorConfig () {
      return {
        maxLength: this.maxLength,
        MENU_CONF: {
          uploadImage: {
            // 自定义图片上传功能
            customUpload: (resultFiles, insertImgFn) => {
              const maxSize = resultFiles.size / 1024 / 1024 < this.maxSize
              if (!maxSize) {
                this.$message.warning(`上传文件大小不能超过 ${this.maxSize}MB!`)
                return false
              }
              const data = new FormData()
              data.append('file', resultFiles)
              fileService.upload(data).then((res) => {
                let url = res.data.includes('http') ? res.data : process.env.VUE_APP_SERVER_URL + res.data
                insertImgFn(url, '', url)
              }).catch((err) => {
                this.$message.error(err)
              })
            }
          },
          uploadVideo: {
            // 自定义视频上传功能
            customUpload: (resultFiles, insertImgFn) => {
              const maxSize = resultFiles.size / 1024 / 1024 < this.maxSize
              if (!maxSize) {
                this.$message.warning(`上传文件大小不能超过 ${this.maxSize}MB!`)
                return false
              }
              const data = new FormData()
              data.append('file', resultFiles)
              fileService.upload(data).then((res) => {
                let url = res.data.includes('http') ? res.data : process.env.VUE_APP_SERVER_URL + res.data
                insertImgFn(url, '', url)
              }).catch((err) => {
                this.$message.error(err)
              })
            }
          }
        }
      }
    }
  },
  data () {
    return {
      editor: null,
      //
      toolbarConfig: {
        toolbarKeys: [
          'headerSelect',
          'bold',
          'clearStyle',
          'italic',
          'color',
          'bgColor',
          '|', 'bulletedList', 'numberedList', 'justifyRight', 'justifyLeft', 'justifyCenter', 'justifyJustify',
          '|',
          'fontSize',
          'fontFamily',
          'lineHeight',
          // 菜单组，包含多个菜单
          {
            key: 'group-image', // 必填，要以 group 开头
            title: '图片', // 必填
            menuKeys: [
              'uploadImage',
              'insertImage',
              'deleteImage',
              'editImage',
              'viewImageLink'
            ]
          },
          {
            key: 'group-video',
            title: '视频',
            iconSvg: '',
            menuKeys: [
              'insertVideo',
              'uploadVideo'
            ]
          },
          {
            key: 'group-link',
            title: '链接',
            menuKeys: ['insertLink', 'editLink', 'unLink', 'viewLink']
          },
          {
            key: 'group-table',
            title: '表格',
            menuKeys: ['insertTable',
              'deleteTable',
              'insertTableRow',
              'deleteTableRow',
              'insertTableCol',
              'deleteTableCol',
              'tableHeader',
              'tableFullWidth'
            ]
          },
          'divider',
          'emotion',
          'blockquote',
          'redo',
          'undo'
        ]
      },
      mode: 'default',
      fontSize: 16,
      // 这个与下边监听的进行对比来判断是否禁用
      isUnbind: 1
    }
  },
  watch: {
    isRelieve (newValue, oldValue) {
      // 这里就完全看各自的需求了
    //   if (newValue === 8) {
    //     this.editor.enable()
    //   } else {
    //     this.editor.disable()
    //     this.isUnbind = oldValue
    //   }
    }
  },
  created () {},
  methods: {
    isKey () {
      // 点击判，是否进入
      if (this.isRelieve !== undefined && this.NextG === this.isRelieve) {
        // this.editor.enable()
        // this.editor.focus()
      }
    },
    onChange (editor) {
    //   this.editorHtml = editor.getHtml()
    },
    onFocus (editor) {
      this.$emit('isShow', editor.getHtml())
    },
    customAlert (info, type) {
      window.alert(`\n${type}:\n${info}`)
    },
    onMaxLength (editor) {
      console.log('onMaxLength', editor)
    },
    onBlur (editor) {
      this.$emit('getIsShow')
    },
    onCreated (editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      if (this.isEdit === true) {
        editor.disable()
      }
      if (this.isEditor === false) {
        editor.disable()
      }
      this.editor.children.map(item => {
        item.children.map(ele => {
          if (ele.text === '') {
            ele.fontFamily = 'Arial'
          }
        })
      })
      // console.log(this.editor.getAllMenuKeys())
    },
    customPaste (editor, event) {
      // const text = event.clipboardData.getData('text/plain') // 获取粘贴的纯文本
      // editor.insertText(text)
      // // 阻止默认的粘贴行为
      // event.preventDefault()
      // return false
    }
  },
  beforeDestroy () {
    const editor = this.editor
    if (editor === null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  props: {
    // 最大字数限制
    maxLength: {
      type: Number,
      default: 0
    },
    backgroundColor: {
      default: '#f2f2f0'
    },
    justifyContent: {
      default: 'end'
    },
    display: {
      default: 'flex'
    },
    borderBottom: {
      default: '1px solid #ccc'
    },
    border: {
      type: String,
      default: '1px solid #ccc'
    },
    borderRadius: {
      type: String,
      default: '4px'
    },
    outerHidden: {
      type: String,
      default: 'hidden'
    },
    outerWidth: {
      type: Number
    },
    height: {
      type: Number,
      default: 700
    },
    width: {
      type: Number
    },
    hidden: {
      type: String,
      default: 'hidden'
    },
    contentHtml: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isEditor: {
      type: Boolean,
      default: true
    },
    isRelieve: {
      type: Number
    },
    idNum: {
      type: String
    },
    maxSize: {
      type: Number,
      default: 5
    },
    NextG: {}
  }
})
</script>